<app-page class="width-100" pageTitle="Active Plan">
  <div class="active-plan-page">
    <div class="header rounded-sm">
      <div class="header-item">Date</div>
      <div class="header-item">VMAX</div>
      <div class="header-item">PROJ</div>
      <div class="header-item">IMAX</div>
    </div>
    <app-plan-table class="width-100 flex-1" [planKey]="0" />
  </div>
</app-page>
